import React, { ReactNode, useContext } from 'react';
import { ConnectionProfile, TeamPermission, useFubConnectionProfilesService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import useFeatureToggleService, { ToggledFeature } from 'feature-toggle';
import { useAuthorizationChecker } from 'authorization-scope';

const FubConnectionReactContext = React.createContext<{
  profiles: ConnectionProfile[],
  loaded: boolean
} | null>(null);

export function useFubConnectionContext() {
  return useContext(FubConnectionReactContext);
}

export function useFubConnectionContextRequired() {
  const result = useFubConnectionContext();

  if (result) {
    return result;
  } else {
    throw new Error('useFubConnectionContextRequired');
  }
}

export function FubConnectionContext(
  props: { children: ReactNode }
) {
  const fubConnectionProfilesService = useFubConnectionProfilesService();

  const featureToggleService = useFeatureToggleService();

  const { isGranted } = useAuthorizationChecker();

  const { data: profiles, loading } = useDataLoaderNew(
    async () => {
      if (isGranted(TeamPermission.READ_FUB_CONNECTION) && featureToggleService.isFeatureEnabled(ToggledFeature.FUB_CONTACTS_INTEGRATION)) {
        return await fubConnectionProfilesService.getProfiles();
      } else {
        return [];
      }
    },
  );

  const value = {
    profiles: profiles ?? [],
    loaded: !loading,
  };

  return (
    <FubConnectionReactContext.Provider
      value={value}
    >
      {props.children}
    </FubConnectionReactContext.Provider>
  );
}
